import * as CryptoJS from "crypto-js";
import { CONSOLE } from "../environments/environment";

export function dataDecrypt(data, text) {
    let parsedData = {};

    if (typeof data === "object") {
        parsedData = data;
    } else {
        let key = CryptoJS.enc.Utf8.parse(atob(CONSOLE.split('').reverse().join('')));
        let iv = CryptoJS.enc.Utf8.parse(atob(CONSOLE.split('').reverse().join('')));
        let dataDecrypted = CryptoJS.AES.decrypt(data, key, { keySize: 256 / 8, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8);
        parsedData = JSON.parse(dataDecrypted);
    }

    return parsedData;
}